export const UPDATE_TRANSACTION_FEE = 'UPDATE_TRANSACTION_FEE';
export const UPDATE_TRANSACTION_FEE_SUCCEED = 'UPDATE_TRANSACTION_FEE_SUCCEED';
export const UPDATE_TRANSACTION_FEE_FAILED = 'UPDATE_TRANSACTION_FEE_FAILED';
